import { __extends } from "tslib";
import { NodeBase } from './NodeBase';
import { PartitionBase } from './PartitionBase';
/**
 * @class away.partition.Partition
 */
var BasicPartition = /** @class */ (function (_super) {
    __extends(BasicPartition, _super);
    function BasicPartition(root) {
        var _this = _super.call(this, root) || this;
        _this._rootNode = new NodeBase(root, _this);
        return _this;
    }
    return BasicPartition;
}(PartitionBase));
export { BasicPartition };
